const state = {
  clipper: {
    opened: null,
    modalData: null,
    MODALS: {
      PREVIEW: "preview",
      SHORTCUTS: "shortcuts",
      TIMEZONE: "timezone",
      SNAPSHOT: "snapshot",
      WATCH_AUDIO: "watch_audio",
      CALENDAR: "calendar",
      MESSAGEMODAL: "message_modal"
    }
  },
  admin: {
    opened: null,
    modalData: null,
    MODALS: {
      ADD: "add_modal",
      EDIT: "edit_modal",
      REMOVE: "remove_modal",
      INFO: "info_modal",
      SOURCE: "source_modal",
      RECORDER: "recorder_modal"
    }
  }
};

const mutations = {
  setOpenedModal(state, { section, modal }) {
    state[section].opened = modal;
  },
  setModalData(state, { section, data }) {
    state[section].modalData = data;
  }
};

const actions = {
  /** common actions */
  openModal({ commit }, { section, modal, data }) {
    if (checkModalExists(section, modal)) {
      commit("setOpenedModal", {
        section,
        modal
      });
      commit("setModalData", {
        section,
        data
      });
    } else {
      console.error(`Modal '${modal}' is not valid modal type`);
    }
  },
  closeModal({ commit }, section) {
    commit("setOpenedModal", {
      section,
      modal: null
    });
  },
  /** clipper actions */
  openClipperModal({ dispatch }, { modal, data }) {
    dispatch("openModal", {
      modal,
      data,
      section: "clipper"
    });
  },
  closeClipperModal({ dispatch }) {
    dispatch("closeModal", "clipper");
  },
  /** admin page actions */
  openAdminModal({ dispatch }, { modal, data }) {
    dispatch("openModal", {
      modal,
      data,
      section: "admin"
    });
  },
  closeAdminModal({ dispatch }) {
    dispatch("closeModal", "admin");
  }
};

function checkModalExists(section, modal) {
  const modalsList = Object.values(state[section].MODALS);
  const modalIndex = modalsList.findIndex(m => m == modal);

  if (modalIndex < 0) {
    return false;
  }

  return true;
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
